import { render, staticRenderFns } from "./CenterBase.vue?vue&type=template&id=be2eb620&scoped=true&"
import script from "./CenterBase.vue?vue&type=script&lang=js&"
export * from "./CenterBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2eb620",
  null
  
)

export default component.exports